// extracted by mini-css-extract-plugin
export default {"pageHeader":"Header_pageHeader__P3siJ","pageTitle":"Header_pageTitle__Vi3+g","pageSubtitle":"Header_pageSubtitle__veCRs"};